module.exports = __webpack_public_path__ + "static/media/bh-logo.bb2ed6da.svg";